// Instructor model based on API::V1::DiscussionTopicSerializer
export default {
  // Attributes
  headline: null,
  introduction: null
}
